var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"personal-away-entitlement-modal","title":"Apply New Away","title-class":"h4 font-weight-bold","lazy":"","size":"lg","hide-footer":""}},[_c('PersonalAwayEntitlementApplyAwayForm',{staticClass:"mx-2",attrs:{"is-busy":_vm.isBusy},on:{"submit-clicked":_vm.submitForm}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }